import { css } from "styled-components";

const buttonStyles = css`
color: #FFFFFF;
background: #33ADFF;
`;

export default buttonStyles;
